import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import Message from '../common/Message';
import ProgramsSection from '../home/ProgramsSection';
import Testimonials from '../home/Testimonials';
import { Gallery } from '../home/Gallery';
const AboutPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white mt-32">
            {/* 页面标题区域 */}
            <div className="bg-gradient-to-r from-blue-800 to-indigo-900 py-16 text-center">
                <motion.h1 
                    className="text-4xl font-bold text-white mb-4"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    {t('about.title', '关于万湖书院')}
                </motion.h1>
                <motion.p 
                    className="text-xl text-blue-100 max-w-3xl mx-auto px-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    {t('about.subtitle', '培养未来的领袖，传承中华文化精髓')}
                </motion.p>
            </div>

            {/* 主要内容区域 */}
            <div className="mx-auto">
                {/* 学校简介 */}
                <motion.section 
                    className="w-full py-24 relative overflow-hidden bg-gradient-to-b from-white to-gray-50"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    {/* 装饰元素 - 背景几何图形 */}
                    <div className="absolute inset-0 z-0 opacity-10">
                        <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-blue-700"></div>
                        <div className="absolute top-40 -left-20 w-64 h-64 rounded-full bg-purple-600"></div>
                        <div className="absolute bottom-20 right-40 w-80 h-80 rounded-full bg-indigo-600"></div>
                    </div>
                    
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                        <div className="mb-16 text-center">
                            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 max-w-4xl mx-auto leading-tight">
                                <span className="inline-block relative">
                                    <span className="relative z-10">{t('about.introduction.title', '学校简介')}</span>
                                    <span className="absolute bottom-2 left-0 w-full h-3 bg-indigo-100 -z-10 transform -rotate-1"></span>
                                </span>
                            </h2>
                        </div>
                        <div className="grid gap-8 items-center">
                            <div>
                                <p className="text-lg text-gray-700 mb-4">
                                    {t('about.introduction.paragraph1', '万湖书院成立于2010年，是一所致力于传承中华文化、培养具有国际视野的优秀人才的教育机构。我们位于美丽的湖畔，环境优美，设施完善，为学生提供了一个理想的学习和成长环境。')}
                                </p>
                                <p className="text-lg text-gray-700 mb-4">
                                    {t('about.introduction.paragraph2', '我们的教育理念融合了中西方教育精华，注重学生的全面发展，培养学生的批判性思维、创新能力和领导力。我们相信，每个学生都有无限的潜能，我们的使命就是帮助他们发掘并发挥这些潜能。')}
                                </p>
                            </div>
                        </div>
                    </div>
                </motion.section>
                <div className="">
                    <div className="">
                        <Gallery />
                    </div>
                    <div className="">
                        <Message />
                    </div>
                    <div className="">
                        <ProgramsSection />
                    </div>
                    <div className="">
                        <Testimonials />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPage; 